import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Grid,
  TextField,
  makeStyles,
  Container,
  Button,
  CardContent,
  Divider,
  InputLabel,
  CardHeader,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Collapse,
  IconButton,
  Tooltip
} from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from "yup";
import PageHeader from 'src/views/Common/PageHeader';
import { useAlert } from "react-alert";
import { LoadingComponent } from '../../../utils/newLoader';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import MaterialTable from "material-table";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  }

}));
var screenCode = "INCENTIVECONFIGURATION"

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      decimalScale={2}
      isNumericString

    />
  );
}
NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function IncentiveConfigurationAddEdit(props) {
  const [title, setTitle] = useState("Add Incentive Configuration")
  const [isUpdate, setIsUpdate] = useState(false);
  const [routeData, setRouteData] = useState([]);
  const [isDisableButton, setIsDisableButton] = useState(false);
  const classes = useStyles();
  const alert = useAlert();
  const [factories, setFactories] = useState();
  const [routes, setRoutes] = useState();
  const [groups, setGroups] = useState();
  const [originalRouteData, setOriginalRouteData] = useState([]);
  const [division, setDivision] = useState({
    groupID: '0',
    factoryID: '0',
    routeID: '0'
  });
  const navigate = useNavigate();


  const handleClick = () => {
    navigate('/app/IncentiveConfiguration/listing');
  }

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const { incentiveConfigurationID } = useParams();
  let decrypted = 0;

  useEffect(() => {
    decrypted = atob(incentiveConfigurationID.toString());
    if (decrypted == 0) {
      setIsUpdate(false);
      setTitle("Add Incentive Configuration")
    }
    else {
      setIsUpdate(true);
      setTitle("Edit Incentive Configuration")
      trackPromise(
        GetIncentiveConfigurationDetailsbyID(decrypted),
      )
    }
  }, [incentiveConfigurationID]);

  useEffect(() => {
    getPermissions();
    getGroupsForDropdown();
  }, []);

  useEffect(() => {
    if (division.groupID !== '0') {
      trackPromise(
        getFactoriesByGroupID()
      );
    }
  }, [division.groupID]);

  useEffect(() => {
    if (division.factoryID !== '0') {
      trackPromise(getRoutesByFactoryID());
    }
  }, [division.factoryID]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITINCENTIVECONFIGURATION');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setDivision({
      ...division,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  async function getFactoriesByGroupID() {
    const fac = await services.getFactoriesByGroupID(division.groupID);
    setFactories(fac);
  }

  async function getRoutesByFactoryID() {
    const fetchedRoutes = await services.getRoutesByGroupIDFactoryID(division.groupID, division.factoryID);
    setRoutes(fetchedRoutes);

    if (!isUpdate) {
      const routeDataArray = Object.entries(fetchedRoutes).map(([key, value]) => ({
        routeID: key,
        routeName: value,
        tiers: [
          {
            tierID: Date.now() + parseInt(key),
            cropWeight: 0,
            amountPerKilo: 0,
            isNew: true,
          }
        ],
      }));
      setRouteData(routeDataArray);
    }
  }


  async function GetIncentiveConfigurationDetailsbyID(incentiveConfigurationID) {
    const response = await services.GetIncentiveConfigurationDetailsbyID(incentiveConfigurationID);
    if (response.statusCode === "Success" && response.data) {
      const rawArray = Array.isArray(response.data) ? response.data : [response.data];

      const routeMap = {};
      rawArray.forEach(row => {
        const rID = row.routeID;
        if (!routeMap[rID]) {
          routeMap[rID] = {
            routeID: rID,
            routeName: row.routeName,
            tiers: [],
          };
        }
        routeMap[rID].tiers.push({
          tierID: row.incentiveConfigurationID,
          incentiveConfigurationID: row.incentiveConfigurationID,
          cropWeight: row.cropWeight,
          amountPerKilo: row.amountPerKilo,
          isNew: false,
        });
      });

      const grouped = Object.values(routeMap);
      setRouteData(grouped);
      const flatOriginals = rawArray.map(row => ({ ...row }));
      setOriginalRouteData(flatOriginals);

      const fetchedGroupID = rawArray[0].groupID;
      const fetchedFactoryID = rawArray[0].factoryID;
      const fetchedRouteID = rawArray[0].routeID;

      setDivision({
        groupID: fetchedGroupID,
        factoryID: fetchedFactoryID,
        routeID: fetchedRouteID,
      });

      const fac = await services.getFactoriesByGroupID(fetchedGroupID);
      setFactories(fac);

      const routeList = await services.getRoutesByGroupIDFactoryID(fetchedGroupID, fetchedFactoryID);
      setRoutes(routeList);

    } else {
      setRouteData([]);
      setOriginalRouteData([]);
    }
  }

  function handleAddTier(routeID) {
    const newArr = routeData.map(route => {
      if (String(route.routeID) === String(routeID)) {
        return {
          ...route,
          tiers: [
            ...route.tiers,
            {
              tierID: Date.now() + Math.random(),
              cropWeight: 0,
              amountPerKilo: 0,
              isNew: true,
              isModified: false,
            }
          ]
        };
      }
      return route;
    });
    setRouteData(newArr);
  }

  function handleRemoveTier(routeID, tierID) {
    const newArr = routeData.map(route => {
      if (String(route.routeID) === String(routeID)) {
        return {
          ...route,
          tiers: route.tiers.filter(t => t.tierID !== tierID)
        };
      }
      return route;
    });
    setRouteData(newArr);
  }

  function handleRateChange(e, routeID, tierID, fieldType) {
    const value = e.target.value;
    const newArr = routeData.map(route => {
      if (String(route.routeID) === String(routeID)) {
        return {
          ...route,
          tiers: route.tiers.map(tier => {
            if (tier.tierID === tierID) {
              return {
                ...tier,
                [fieldType]: value === '' ? 0 : parseFloat(value),
                isModified: true,
              };
            }
            return tier;
          })
        };
      }
      return route;
    });
    setRouteData(newArr);
  }
  function validateRouteData() {
    for (const route of routeData) {
      for (const tier of route.tiers) {
        const hasCropWeight = tier.cropWeight !== 0 && tier.cropWeight !== '';
        const hasAmountPerKilo = tier.amountPerKilo !== 0 && tier.amountPerKilo !== '';
        if ((hasCropWeight && !hasAmountPerKilo) || (!hasCropWeight && hasAmountPerKilo)) {
          return { isValid: false, message: `Route "${route.routeName}": Both "Apply Incentive Above" and "Incentive Rate" must be filled together.` };
        }
      }

      const filledTiers = route.tiers.filter(t => t.cropWeight !== 0 && t.cropWeight !== '');
      const cropWeightValues = filledTiers.map(t => parseFloat(t.cropWeight));
      const uniqueCropWeights = new Set(cropWeightValues);
      if (uniqueCropWeights.size !== cropWeightValues.length) {
        return {
          isValid: false,
          message: `Route "${route.routeName}": Duplicate "Apply Incentive Above" values found. Each tier must have a unique kg value.`
        };
      }
    }
    return { isValid: true, message: '' };
  }

  async function saveConfiguration(values) {
    const validation = validateRouteData();
    if (!validation.isValid) {
      alert.error(validation.message);
      return;
    }

    if (isUpdate) {
      const newTiers = [];
      const changedExistingTiers = [];

      routeData.forEach(route => {
        route.tiers.forEach(tier => {
          if (tier.isNew && tier.isModified && tier.cropWeight !== 0 && tier.amountPerKilo !== 0) {
            newTiers.push({
              routeID: route.routeID,
              routeName: route.routeName,
              cropWeight: tier.cropWeight,
              amountPerKilo: tier.amountPerKilo,
            });
          } else if (!tier.isNew && tier.isModified) {
            changedExistingTiers.push({
              incentiveConfigurationID: tier.incentiveConfigurationID,
              groupID: division.groupID,
              factoryID: division.factoryID,
              routeID: route.routeID,
              cropWeight: tier.cropWeight,
              amountPerKilo: tier.amountPerKilo,
            });
          }
        });
      });

      if (changedExistingTiers.length === 0 && newTiers.length === 0) {
        alert.info("No changes to save.");
        return;
      }

      for (const model of changedExistingTiers) {
        let response = await services.updateConfiguration([model]);
        if (response.statusCode !== "Success") {
          alert.error(response.message);
          return;
        }
      }

      if (newTiers.length > 0) {
        let saveModel = {
          groupID: division.groupID,
          factoryID: division.factoryID,
          routes: newTiers.map(t => ({
            routeID: t.routeID,
            cropWeight: t.cropWeight,
            amountPerKilo: t.amountPerKilo,
          })),
        };
        let response = await services.saveConfiguration(saveModel);
        if (response.statusCode !== "Success") {
          alert.error(response.message);
          return;
        }
      }

      alert.success("Incentive Configuration updated successfully");
      setIsDisableButton(true);
      navigate('/app/IncentiveConfiguration/listing');

    } else {
      const routesToSave = [];
      routeData.forEach(route => {
        route.tiers.forEach(tier => {
          if (tier.isModified && tier.cropWeight !== 0 && tier.amountPerKilo !== 0) {
            routesToSave.push({
              routeID: route.routeID,
              cropWeight: tier.cropWeight,
              amountPerKilo: tier.amountPerKilo,
            });
          }
        });
      });

      if (routesToSave.length === 0) {
        alert.info("No changes to save.");
        return;
      }

      let saveModel = {
        groupID: values.groupID,
        factoryID: values.factoryID,
        routes: routesToSave,
      };
      let response = await services.saveConfiguration(saveModel);

      if (response.statusCode === "Success") {
        alert.success(response.message);
        setIsDisableButton(true);
        navigate('/app/IncentiveConfiguration/listing');
      } else {
        alert.error(response.message);
      }
    }
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  function handleChange1(e) {
    const target = e.target;
    const name = target.name;
    let value = target.value;

    setDivision((prevState) => ({
      ...prevState,
      [name]: value
    }));
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClick}
          />
        </Grid>
      </Grid>
    )
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: division.groupID,
              factoryID: division.factoryID,
              routeID: division.routeID,
            }}
            validationSchema={
              isUpdate
                ? Yup.object().shape({})
                : Yup.object().shape({
                  groupID: Yup.number().required('Group required').min(1, 'Group required'),
                  factoryID: Yup.number().required('Estate required').min(1, 'Estate required'),
                })
            }
            onSubmit={saveConfiguration}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values,
              props
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <Divider />
                    <CardContent>
                      <Grid container spacing={3}>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="groupID">
                            Group *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.groupID && errors.groupID)}
                            fullWidth
                            helperText={touched.groupID && errors.groupID}
                            size='small'
                            name="groupID"
                            onBlur={handleBlur}
                            onChange={(e) => handleChange1(e)}
                            value={values.groupID}
                            variant="outlined"
                            id="groupID"
                            InputProps={{
                              readOnly: isUpdate || !permissionList.isGroupFilterEnabled ? true : false,
                            }}
                          >
                            <MenuItem value="0">--Select Group--</MenuItem>
                            {generateDropDownMenu(groups)}
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="factoryID">
                            Factory *
                          </InputLabel>
                          <TextField select
                            fullWidth
                            name="factoryID"
                            onChange={(e) => handleChange1(e)}
                            size='small'
                            value={values.factoryID}
                            variant="outlined"
                            id="factoryID"
                            InputProps={{
                              readOnly: isUpdate || !permissionList.isFactoryFilterEnabled ? true : false
                            }}
                          >
                            <MenuItem value={1}>--Select Factory--</MenuItem>
                            {generateDropDownMenu(factories)}
                          </TextField>
                        </Grid>
                      </Grid>
                    </CardContent>

                    {routeData.length > 0 && (
                      <Grid item md={12} xs={12} style={{ marginTop: '16px' }}>
                        <Grid className={classes.container}>
                          <Collapse in={true}>
                            <Paper elevation={0} className={classes.paper}>
                              <Grid container spacing={4}>
                                <Grid item xs={12}>
                                  <TableContainer>
                                    <Table className={classes.table} aria-label="incentive configuration table">
                                      <TableHead>
                                        <TableRow>
                                          <TableCell align={'left'}>Route</TableCell>
                                          <TableCell align={'center'}>Apply Incentive Above (kg)</TableCell>
                                          <TableCell align={'center'}>Incentive Rate (Rs)</TableCell>
                                          {!isUpdate && (
                                            <TableCell align={'center'}>Action</TableCell>
                                          )}
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {routeData.map((route, routeIndex) => (
                                          route.tiers.map((tier, tierIndex) => {
                                            const hasCropWeight = tier.cropWeight !== 0 && tier.cropWeight !== '';
                                            const hasAmountPerKilo = tier.amountPerKilo !== 0 && tier.amountPerKilo !== '';
                                            const showError = (hasCropWeight && !hasAmountPerKilo) || (!hasCropWeight && hasAmountPerKilo);

                                            return (
                                              <TableRow key={`${route.routeID}-${tier.tierID}`}>
                                                <TableCell
                                                  align={'left'}
                                                  component="th"
                                                  scope="row"
                                                  style={{ borderBottom: tierIndex === route.tiers.length - 1 ? undefined : 'none' }}
                                                >
                                                  {tierIndex === 0 ? route.routeName : ''}
                                                </TableCell>

                                                <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: 'none' }}>
                                                  <TextField
                                                    error={showError}
                                                    helperText={showError ? "Both fields must be filled or both empty" : ""}
                                                    name="cropWeight"
                                                    onBlur={handleBlur}
                                                    onChange={(e) => handleRateChange(e, route.routeID, tier.tierID, "cropWeight")}
                                                    value={tier.cropWeight === 0 ? '' : tier.cropWeight}
                                                    type='number'
                                                    variant="outlined"
                                                    size='small'
                                                    inputProps={{
                                                      style: { textAlign: 'right' },
                                                      min: 1,
                                                      step: "0.01"
                                                    }}
                                                  />
                                                </TableCell>

                                                <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: 'none' }}>
                                                  <TextField
                                                    error={showError}
                                                    type='number'
                                                    helperText={showError ? "Both fields must be filled or both empty" : ""}
                                                    name="amountPerKilo"
                                                    onBlur={handleBlur}
                                                    onChange={(e) => handleRateChange(e, route.routeID, tier.tierID, "amountPerKilo")}
                                                    value={tier.amountPerKilo === 0 ? '' : tier.amountPerKilo}
                                                    variant="outlined"
                                                    size='small'
                                                    inputProps={{
                                                      style: { textAlign: 'right' },
                                                      min: 1,
                                                      step: "0.01"
                                                    }}
                                                  />
                                                </TableCell>
                                                {!isUpdate && (
                                                  <TableCell align={'center'} style={{ borderBottom: 'none' }}>
                                                    {tierIndex === route.tiers.length - 1 && (
                                                      <Tooltip title="Add incentive tier">
                                                        <IconButton
                                                          size="small"
                                                          color="primary"
                                                          onClick={() => handleAddTier(route.routeID)}
                                                        >
                                                          <AddCircleOutlineIcon />
                                                        </IconButton>
                                                      </Tooltip>
                                                    )}
                                                    {route.tiers.length > 1 && (
                                                      <Tooltip title="Remove tier">
                                                        <IconButton
                                                          size="small"
                                                          color="secondary"
                                                          onClick={() => handleRemoveTier(route.routeID, tier.tierID)}
                                                        >
                                                          <DeleteIcon />
                                                        </IconButton>
                                                      </Tooltip>
                                                    )}
                                                  </TableCell>
                                                )}
                                              </TableRow>
                                            );
                                          })
                                        ))}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </Grid>
                              </Grid>
                            </Paper>
                          </Collapse>
                        </Grid>
                      </Grid>
                    )}
                    <Box display="flex" justifyContent="flex-end" p={2}>
                      <Button
                        color="primary"
                        style={{ margin: 10, justifyContent: 'flex' }}
                        variant="contained"
                        type="submit"
                        disabled={isDisableButton}
                      >
                        {isUpdate ? "Update" : "Save"}
                      </Button>
                    </Box>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
};


